<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="ball-atom" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
    <div class="card ">
        <div class="card-body">
            <div class="card-header bg-warning">
                <div style="float:left;">
                    <h2><i class="fa fa-users"></i>การประเมินชาวไร่(ตามหัวข้อที่ส่วนกลางบันทึก)</h2>
                </div>
            </div>
            <div class="row">
                <div>
                    <form [formGroup]="Actioncmg">
                        <div class="row">
                            <div class="col-md-5">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-5">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>เลือกโซน</mat-label>
                                                    <select matNativeControl formControlName="selectzone" name="abc">
                                                        <option value="" selected>-- ทุกโซน --</option>
                                                        <option *ngFor="let item of zonecode" [value]="item.SUPZONE">
                                                            {{item.SUPZONE}}-|-{{item.ZONENAME}}
                                                        </option>
                                                    </select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-5">
                                                <mat-form-field class="example-full-width" appearance="fill">
                                                    <mat-label>ค้นหาชาวไร่</mat-label>
                                                    <input matInput formControlName="term" placeholder="Search Here">
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="example-button-row">
                                                    <button mat-raised-button color="primary"
                                                        (click)="svFm()">ค้นหา</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body table-responsive p-2" style="height: 550px">
                                        <table
                                            class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th style="text-align:center;">No</th>
                                                    <th>โควตา</th>
                                                    <th>ชื่อชาวไร่</th>
                                                    <th style="text-align:center;">โซน</th>
                                                    <th>รายการ</th>
                                                    <th style="text-align:center;">เลือก</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of dataResult index as i">
                                                    <td style="text-align:center;">{{i+1}}</td>
                                                    <td>{{item.FMCODE}}</td>
                                                    <td>{{item.fmname}}</td>
                                                    <td style="text-align:center;">{{item.SUPZONE}}</td>
                                                    <td>{{item.knowledge}}</td>
                                                    <td style="text-align:center;"><i
                                                            class='fas fa-chevron-circle-right'
                                                            style='font-size:28;color:green'
                                                            (click)="setFMdata(item.FMCODE)"></i></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="card-body">
                                    <div class="card">
                                        <div class="card-header">รายการข้อมูลที่เลือก {{fmSelect | json}}</div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-sm-3 border border-dark"
                                                    *ngFor="let item of main_topic ; let i = index;">
                                                    <mat-list>
                                                        <hr>
                                                        <mat-list-item>
                                                            <p style="font-size:18px;">{{item.id}}.{{item.name}}</p>
                                                        </mat-list-item>
                                                        <hr>
                                                    </mat-list>
                                                    <div *ngFor="let li of sub_topic">
                                                        <label class="container"
                                                            *ngIf="li.type.trim()===item.Ltype.trim()">
                                                            <input type="checkbox" [(ngModel)]="li.completed"
                                                                (ngModelChange)="loadDataFT(1);"
                                                                [ngModelOptions]="{standalone: true}">
                                                            <span class="checkmark"> &nbsp;{{li.name}} {{li.completed}}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <p>data: {{dataAft | json}}</p>
                                                </div>
                                                <div class="col-sm-3" *ngIf="fmSelect.length>0">
                                                    <button mat-raised-button color="primary"
                                                        (click)="saveKnowledge()">OK</button>
                                                </div>
                                                <div class="col-sm-3">
                                                    <button mat-raised-button color="warn"
                                                        (click)="loadDataFT(2);">Clear</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--
                                <div class="card-body table-responsive p-2" style="height: 300px">
                                    <table class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap" style="width:100%" >
                                        <thead>
                                            <tr>
                                                <th style="text-align:center"></th>
                                                <th>โควตา</th>
                                                <th>ชื่อชาวไร่</th>
                                                <th style="text-align:center">โซน</th>
                                                <th style="text-align:center">การอบรม</th>                                                
                                                <th>วันที่อัพเดต</th>
                                                <th>หมายเหตุ</th>
                                                <th ></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of SubTraindata; let i = index;">
                                                <td style="text-align:center">{{i+1 | number}}</td>
                                                <td>{{item.fmcode}}</td>
                                                <td>{{item.fmname}}</td>
                                                <td style="text-align:center">{{item.supzone}}</td>
                                                <td style="text-align:right">{{item.results_desc}}
                                                    <button mat-button [matMenuTriggerFor]="editresults" #menuTrigger>
                                                        <a class='far fa-edit' style='font-size:20;color:red'> </a>
                                                    </button>
                                                    <mat-menu #editresults="matMenu">
                                                        <button type="button" class="btn btn-outline-success" (click)="getdata(item.fmcode,item.fmname,0)" *ngIf="item.results!=0">เข้าอบรม</button>
                                                        <button type="button" class="btn btn-outline-primary" (click)="getdata(item.fmcode,item.fmname,1)" *ngIf="item.results!=1">ผ่านการอบรม</button>
                                                    </mat-menu>
                                                </td>
                                                <td>{{THtoLocalstring(item.date_update)}}</td>
                                                <td>{{item.comment}}</td>
                                                <td style="text-align:center;"><i class='fas fa-times' style='font-size:24px;color:red' (click)="CancleTrain(item.pr_id)"></i></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                -->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>